import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";

// Styles for the video and overlay using @material-ui/core's makeStyles
const useStyles = makeStyles((theme) => ({
  videoBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    zIndex: -1, // Ensure the video is behind the content
  },
  videoOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.5)", // Semi-transparent overlay
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    textAlign: "center",
    padding: theme.spacing(4),
  },
}));

const Content = () => {
  const classes = useStyles(); // Get the styles

  return (
    <Box id="top" component="section">
      <div class="caption" style={{ padding: "0px 60px 0px 60px", opacity: "0.9", marginTop: "1rem", width: "70%" }}>
        <h2
          style={{
            fontStyle: "normal",
            color: "#f5a425",
            fontSize: "30px",
            fontWeight: "900",
            marginTop: "10px",
            textTransform: "uppercase",
            letterSpacing: "1px",
          }}
        >
          <em style={{ fontStyle: "normal" }}>Fast &amp; Simplified Trust based Plan Approval System</em>
        </h2>
        <p style={{ color: "#fff", fontSize: "14px", maxWidth: "570px" }}>
          Fast &amp; Simplified Trust based Plan Approval System with EDCR or auto scutiny of maps in the State of Uttar Pradesh.
        </p>
        <h2
          style={{
            fontStyle: "normal",
            color: "#f5a425",
            fontSize: "30px",
            fontWeight: "900",
            marginTop: "10px",
            textTransform: "uppercase",
            letterSpacing: "1px",
          }}
        >
          <em style={{ fontStyle: "normal" }}>EDCR Scrutiny Engine:</em>
        </h2>
        <p style={{ color: "#fff", fontSize: "14px", maxWidth: "570px" }}>
          E-DCR is an Automatic Scrutiny of Building Plans and Building Plans Approval Management System. It is a unique software that Scans CAD
          drawings and maps them to development rules for approval by municipal bodies. One Product to get Building Plan Approvals across the
          State-wide
        </p>

        <h4 style={{ fontSize: "23px", textTransform: "uppercase", fontWeight: "800", letterSpacing: "1px", color: "#0ef10e", marginTop: "10px" }}>
          One Product to get Building Plan Approvals across the State-wide
        </h4>
      </div>
    </Box>
  );
};

export default Content;
